export default {
  'areas.title': 'Manage Areas',
  'areas.form.id': 'ID',
  'areas.form.enable': 'Enable',
  'areas.form.name': 'Name',
  'areas.form.description': 'Description',
  'areas.form.statusLabel': 'Is Enabled?',
  'areas.enabled': 'Enable',
  'areas.disabled': 'Disable',
  'areas.title.import': 'Import Areas',
};
